import React from 'react'
import PropTypes from 'prop-types'
import ClassNames from 'classnames'
import { SelectStyle } from './styled'
import { default as ReactSelect } from 'react-select'
import { consolidateStreamedStyles } from 'styled-components'
import { AsyncPaginate } from 'react-select-async-paginate'
import { default as VARIABLES } from '../../themes/styles/variables'

const SelectBoxPredecessor = props => {
  const { className, fieldValue, isErrCategory } = props
  const selectAll = [{ label: 'Select all', value: 'All' }]
  const selectNotAll = []
  if (typeof fieldValue !== 'undefined' && fieldValue) {
    if (fieldValue.length === props.options.length) {
      Array.prototype.push.apply(selectAll, fieldValue)
    } else {
      Array.prototype.push.apply(selectNotAll, fieldValue)
    }
  }
  const checkSelectAll =
    typeof fieldValue !== 'undefined' &&
    fieldValue &&
    fieldValue.length === props.options.length
  const customStyles = {
    placeholder: (base, { isDisabled }) => ({
      ...base,
      color: isDisabled ? VARIABLES.COLORS.GRAY_10 : VARIABLES.COLORS.GRAY_3,
    }),

    singleValue: (base, { isDisabled }) => ({
      ...base,
      color: isDisabled ? VARIABLES.COLORS.GRAY_10 : VARIABLES.COLORS.GRAY_3,
      outline: 'none',
    }),

    control: (base, { isDisabled }) => ({
      ...base,
      whiteSpace: 'nowrap',
      boxShadow: 'none',
      borderColor: VARIABLES.COLORS.GRAY_2,
      '&:hover': {
        borderColor: VARIABLES.COLORS.GRAY_2,
      },
      backgroundColor: isDisabled ? VARIABLES.COLORS.GRAY_8 : undefined,
      height: '42px',
      '@media only screen and (min-width: 1601px)': {
        ...base['@media only screen and (min-width: 1601px)'],
        minWidth: '150px',
      },
    }),

    indicatorSeparator: base => ({
      ...base,
      display: 'none',
    }),

    dropdownIndicator: (base, { isDisabled }) => ({
      ...base,
      color: isDisabled ? VARIABLES.COLORS.GRAY_10 : VARIABLES.COLORS.BLUE_1,
      '&:hover': {
        color: isDisabled ? VARIABLES.COLORS.GRAY_10 : VARIABLES.COLORS.BLUE_1,
      },
    }),

    option: (styles, { isDisabled, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isDisabled
          ? undefined
          : isSelected
          ? VARIABLES.COLORS.BLUE_1
          : undefined,
        '&:hover': {
          backgroundColor: isDisabled
            ? VARIABLES.COLORS.GRAY_4
            : isSelected
            ? VARIABLES.COLORS.BLUE_1
            : VARIABLES.COLORS.GRAY_4,
        },
      }
    },
  }
  const asyncSelectBox = () => {
    const { options, allOption } = props
    const allSelectOptions = options
    const sleep = ms => {
      new Promise(resolve => {
        setTimeout(() => {
          resolve()
        }, ms)
      })
    }
    const loadOptions = async (search, prevOptions) => {
      await sleep(1000)
      let filteredOptions
      if (allSelectOptions) {
        if (!search) {
          filteredOptions = allSelectOptions
        } else {
          const searchLower = search.toLowerCase()
          filteredOptions = allSelectOptions.filter(({ label }) =>
            label.toLowerCase().includes(searchLower)
          )
        }
        const hasMore = filteredOptions.length > prevOptions.length + 10
        const slicedOptions = filteredOptions.slice(
          prevOptions.length,
          prevOptions.length + 10
        )
        return {
          options: slicedOptions,
          hasMore,
        }
      }
    }
    return (
      <SelectStyle className={ClassNames('select-control', className)}>
        <AsyncPaginate
          loadOptions={loadOptions}
          {...props}
          noOptionsMessage={() => "Can't find Predecessor"}
          placeholder="Select Predecessor"
          styles={customStyles}
          value={fieldValue}
        />
      </SelectStyle>
    )
  }
  return asyncSelectBox()
}

SelectBoxPredecessor.propTypes = {
  options: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  allowSelectAll: PropTypes.bool,
  allOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
}

SelectBoxPredecessor.defaultProps = {
  allOption: {
    label: 'Select all',
    value: 'All',
  },
  className: '',
  isErrCategory: '',
}

export { SelectBoxPredecessor }
